import {
	buildPOSTContract,
	serializePathBasic,
	HttpStatus,
	CommonResponses,
} from "@/common/contracts";
import { z } from "zod";
import { RegisterPushNotificationsDeviceInputSchema } from "./RegisterPushNotificationsDeviceInput";
import { RegisterPushNotificationsDeviceOutputSchema } from "./RegisterPushNotificationsDeviceOutput";
import { UserRole } from "@/users/models/UserRole";

export const RegisterPushNotificationsDeviceContract = buildPOSTContract({
	path: "/notifications/register-device",
	method: "POST",
	search: z.object({}),
	params: z.object({}),

	body: RegisterPushNotificationsDeviceInputSchema,
	serializePath(
		params: z.infer<typeof this.params>,
		search: z.infer<typeof this.search>,
	) {
		return serializePathBasic(this.path, params, search);
	},
	response: z.discriminatedUnion("status", [
		...CommonResponses,
		z.object({
			status: z.literal(HttpStatus.Success),
			body: RegisterPushNotificationsDeviceOutputSchema,
		}),
	]),
});
